import { render } from "./ButtonXRound.vue?vue&type=template&id=de68e64e&scoped=true"
const script = {}

import "./ButtonXRound.vue?vue&type=style&index=0&id=de68e64e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-de68e64e"

export default script